import { VpcService } from '@inter-ikea-kompis/services'
import type { IDexfSettings } from '@inter-ikea-kompis/types'

import { KOMPIS_SERVICE_BASE_SETTINGS } from '@/integrations/kompis/constants'
import { redirectHome } from '@/utils/redirects'

export async function getConfigurationFromDesignCodeOrRedirectHome(dexfSettings: IDexfSettings, designCode: string) {
  const vpcService = new VpcService({
    ...KOMPIS_SERVICE_BASE_SETTINGS,
    settings: dexfSettings,
  })

  try {
    const configuration = await vpcService.getConfiguration(designCode)

    if (!configuration) throw redirectHome()

    return configuration
  } catch (_error) {
    throw redirectHome()
  }
}
